/**
 * Sélecteurs pour la gestion de la boîte de dialogue de confirmation
 * @category Dialogs
 * @hideconstructor
 */
var ConfirmDialogStoreSelector = /*#__PURE__*/function () {
  function ConfirmDialogStoreSelector() {}

  /**
   * Sélection des informations sur la boîte de dialogue
   * @param {object} state state de l'application
   * @returns {ConfirmDialogObject} Objet contenant les informations sur la boîte de dialogue
   */
  ConfirmDialogStoreSelector.selectConfirmDialog = function selectConfirmDialog(state) {
    return state.manageConfirmDialog.confirmDialog;
  }
  /**
   * Sélection de la variable d'état (affichée/cachée) de la boîte de dialogue
   * @param {object} state state de l'application
   * @returns {boolean} true si la boîte de dialogue est affichée, false sinon
   */
  ;

  ConfirmDialogStoreSelector.selectOpen = function selectOpen(state) {
    return ConfirmDialogStoreSelector.selectConfirmDialog(state).open;
  }
  /**
   * Sélection du message de la boîte de dialogue
   * @param {object} state state de l'application
   * @returns {string} Message de la boîte de dialogue
   */
  ;

  ConfirmDialogStoreSelector.selectMessage = function selectMessage(state) {
    return ConfirmDialogStoreSelector.selectConfirmDialog(state).message;
  }
  /**
   * Sélection du callback de validation de la boîte de dialogue
   * @param {object} state state de l'application
   * @returns {function} Callback de validation de la boîte de dialogue
   */
  ;

  ConfirmDialogStoreSelector.selectOnValid = function selectOnValid(state) {
    return ConfirmDialogStoreSelector.selectConfirmDialog(state).onValid;
  }
  /**
   * Sélection du callback d'annulation de la boîte de dialogue
   * @param {object} state state de l'application
   * @returns {function} Callback de d'annulation de la boîte de dialogue
   */
  ;

  ConfirmDialogStoreSelector.selectOnCancel = function selectOnCancel(state) {
    return ConfirmDialogStoreSelector.selectConfirmDialog(state).onCancel;
  };

  return ConfirmDialogStoreSelector;
}(); // Exports


export var selectConfirmDialog = ConfirmDialogStoreSelector.selectConfirmDialog;
export var selectOpen = ConfirmDialogStoreSelector.selectOpen;
export var selectMessage = ConfirmDialogStoreSelector.selectMessage;
export var selectOnValid = ConfirmDialogStoreSelector.selectOnValid;
export var selectOnCancel = ConfirmDialogStoreSelector.selectOnCancel;